import { Button, Card, DateInput, Field, Notice } from '@growup/ui';
import { useState } from 'react';

import { download, messageOf } from '../api';

function monthStart(): string {
  const now = new Date();
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1)).toISOString().slice(0, 10);
}

/** Sales export for accounting: one row per order line, paid orders only. */
export function ReportsView() {
  const [from, setFrom] = useState(monthStart);
  const [to, setTo] = useState(() => new Date().toISOString().slice(0, 10));
  const [error, setError] = useState<string | null>(null);

  const get = () => {
    setError(null);
    const params = new URLSearchParams({ from, to });
    download(
      `/api/site/store/reports/sales.csv?${params.toString()}`,
      `vendas-${from}-${to}.csv`,
    ).catch((e: unknown) => setError(messageOf(e)));
  };

  return (
    <Card headingLevel={2} title="Vendas" className="max-w-xl">
      <div className="flex flex-col gap-4">
        <p className="text-body text-gu-ink-muted">
          Encomendas pagas no período, uma linha por artigo, em CSV (abre no Excel).
        </p>
        <div className="grid grid-cols-2 gap-3">
          <Field label="De">
            <DateInput value={from} onChange={setFrom} max={to || undefined} />
          </Field>
          <Field label="Até">
            <DateInput value={to} onChange={setTo} min={from || undefined} />
          </Field>
        </div>
        {error ? <Notice tone="danger">{error}</Notice> : null}
        <div>
          <Button disabled={!from || !to || from > to} onClick={get}>
            Descarregar CSV
          </Button>
        </div>
      </div>
    </Card>
  );
}
